import React from 'react'

const RadioSelected = ({ title, ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    {...props}
  >
    <title>{title}</title>
    <g fill="none" fillRule="nonzero">
      <circle cx="8" cy="8" r="6.5" fill="#1557BF" stroke="#0D3578" />
      <circle cx="8" cy="8" r="3" fill="#FFF" />
    </g>
  </svg>
)

export default RadioSelected
